export default {
  'app.setting.pagestyle': 'Cài đặt phong cách tổng thể',
  'app.setting.pagestyle.dark': 'Phong cách menu tối',
  'app.setting.pagestyle.light': 'Phong cách menu sáng',
  'app.setting.pagestyle.realdark': 'Phong cách tối (tính năng thử nghiệm)',
  'app.setting.content-width': 'Chiều rộng vùng nội dung',
  'app.setting.content-width.fixed': 'Cố định',
  'app.setting.content-width.fluid': 'Co giãn theo màn hình',
  'app.setting.themecolor': 'Màu chủ đề',
  'app.setting.themecolor.dust': 'Màu hoàng hôn đỏ',
  'app.setting.themecolor.volcano': 'Màu núi lửa',
  'app.setting.themecolor.sunset': 'Màu hoàng hôn',
  'app.setting.themecolor.cyan': 'Xanh lam sáng',
  'app.setting.themecolor.green': 'Xanh cực quang',
  'app.setting.themecolor.techBlue': 'Xanh công nghệ (mặc định)',
  'app.setting.themecolor.daybreak': 'Màu bình minh',
  'app.setting.themecolor.geekblue': 'Xanh geek',
  'app.setting.themecolor.purple': 'Tím rượu vang',
  'app.setting.navigationmode': 'Chế độ điều hướng',
  'app.setting.sidermenutype': 'Kiểu menu bên',
  'app.setting.sidermenutype-sub': 'Chế độ cổ điển',
  'app.setting.sidermenutype-group': 'Chế độ phân nhóm',
  'app.setting.regionalsettings': 'Vùng nội dung',
  'app.setting.regionalsettings.header': 'Thanh trên cùng',
  'app.setting.regionalsettings.menu': 'Menu',
  'app.setting.regionalsettings.footer': 'Chân trang',
  'app.setting.regionalsettings.menuHeader': 'Đầu menu',
  'app.setting.sidemenu': 'Bố cục menu bên',
  'app.setting.topmenu': 'Bố cục menu trên',
  'app.setting.mixmenu': 'Bố cục menu hỗn hợp',
  'app.setting.splitMenus': 'Tự động tách menu',
  'app.setting.fixedheader': 'Cố định Header',
  'app.setting.fixedsidebar': 'Cố định menu bên',
  'app.setting.fixedsidebar.hint': 'Chỉ khả dụng khi dùng bố cục menu bên',
  'app.setting.hideheader': 'Ẩn Header khi cuộn xuống',
  'app.setting.hideheader.hint': 'Chỉ khả dụng khi Header được cố định',
  'app.setting.othersettings': 'Cài đặt khác',
  'app.setting.weakmode': 'Chế độ hỗ trợ người mù màu',
  'app.setting.copy': 'Sao chép cấu hình',
  'app.setting.loading': 'Đang tải chủ đề',
  'app.setting.copyinfo': 'Sao chép thành công, vui lòng thay thế cấu hình mặc định trong src/defaultSettings.js',
  'app.setting.production.hint': 'Thanh cấu hình chỉ dùng trong môi trường phát triển để xem trước, sẽ không hiển thị ở môi trường sản xuất. Hãy sao chép và chỉnh sửa thủ công trong file cấu hình.'
};
